<template>
  <span class="icon-indicator" :class="[theme, type]" v-if="imageSrc">
    <img class="icon" :src="imageSrc" />
  </span>
</template>

<script>
import get from 'lodash/get'
import { getArticleType } from 'mixins/utilities'

export default {
  props: {
    theme: {
      type: String,
      default: 'normal',
    },
  },
  data() {
    return {
      type: false,
    }
  },
  computed: {
    hasRelatedAmpStory() {
      return get(this, 'node.hasRelatedAmpStory')
    },
    hasCardVideo() {
      return get(this, 'node.card.isVideo')
    },
    articleType() {
      return getArticleType(this.node)
    },
    imageSrc() {
      if (this.articleType === 'podcast') {
        this.type = 'podcast'
        return this.theme === 'small' ? '/static/svg/icon_indicator_podcast_small.svg' : '/static/svg/icon_indicator_podcast.svg'
      } else if (this.hasCardVideo) {
        this.type = 'video'
        return this.theme === 'small' ? '/static/svg/icon_indicator_video_small.svg' : '/static/svg/icon_indicator_video.svg'
      } else if (this.hasRelatedAmpStory) {
        this.type = 'amp'
        return this.theme === 'small' ? '/static/svg/icon_indicator_amp_story_small.svg' : '/static/svg/icon_indicator_amp_story.svg'
      }
      return false
    },
  },
}
</script>
<style lang="scss" scoped>
  .small {
    &.amp {
      width: rem-calc(20);
      height: rem-calc(15);
    }
    &.podcast {
      width: rem-calc(13);
      height: rem-calc(18);
    }
    &.video {
      width: rem-calc(18);
      height: rem-calc(18);
    }
  }

  span {
    width: rem-calc(66);
    height: rem-calc(66);
    z-index: 3;
    position: absolute;

    & > .icon {
      display: flex;
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// components/article-levels/IconIndicator.vue